var _defs, _rect, _rect2, _rect3, _path, _path2, _rect4, _path3, _path4, _path5, _rect5, _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _line, _line2, _line3, _line4, _line5, _path6, _path7, _path8, _path9, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 164",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "night-sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#050c18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#081420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#0e2030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c1c28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "beacon-flare",
    cx: "62%",
    cy: "28%",
    r: "45%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff4a0",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#ffb030",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#e06010",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#0e2030",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0e2030",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sea-mist",
    cx: "50%",
    cy: "30%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a3840",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#0e2030",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050c18",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cliff-c",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#111808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060c04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sea-c",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e2838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#081820"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#night-sky)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#beacon-flare)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95,
    width: 200,
    height: 69,
    fill: "url(#sea-c)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 100 Q30 95 60 100 Q90 104 120 98 Q150 94 180 100 Q190 102 200 100 L200 95 Q170 90 140 96 Q110 100 80 96 Q50 90 20 96 Q10 98 0 96Z",
    fill: "#0c2030",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 110 Q40 105 80 110 Q120 114 160 108 Q180 106 200 110 L200 105 Q165 100 130 106 Q90 110 50 106 Q25 102 0 106Z",
    fill: "#0a1c2c",
    opacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#sea-mist)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 130 Q50 124 100 128 Q150 122 200 126 L200 164 L0 164Z",
    fill: "url(#cliff-c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95 130 Q95 90 90 78 Q95 75 100 75 Q105 75 110 78 Q105 90 105 130Z",
    fill: "#0e1408",
    opacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 130 Q98 120 96 110 Q95 100 95 88 Q97 82 100 80 Q103 82 105 88 Q105 100 104 110 Q102 120 100 130Z",
    fill: "#1a2010",
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 58,
    width: 8,
    height: 20,
    rx: 1,
    fill: "#2a1808",
    stroke: "#8a4010",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 52,
    r: 10,
    fill: "#1a0e04",
    stroke: "#e08020",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 52,
    r: 7,
    fill: "#ff8010",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 52,
    r: 4,
    fill: "#ffcc40",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 52,
    r: 2,
    fill: "#fff8a0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 52,
    rx: 16,
    ry: 16,
    fill: "none",
    stroke: "#e08020",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 52,
    rx: 24,
    ry: 22,
    fill: "none",
    stroke: "#c06010",
    strokeWidth: 0.3,
    opacity: 0.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 36,
    x2: 100,
    y2: 28,
    stroke: "#ffb030",
    strokeWidth: 1,
    strokeLinecap: "round",
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 52,
    x2: 126,
    y2: 52,
    stroke: "#ffa020",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 52,
    x2: 74,
    y2: 52,
    stroke: "#ffa020",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 40,
    x2: 120,
    y2: 34,
    stroke: "#ff9010",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    opacity: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 40,
    x2: 80,
    y2: 34,
    stroke: "#ff9010",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95 Q65 90 58 85 Q55 88 58 93Z",
    fill: "#0a1820",
    opacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100 Q58 94 52 88 Q48 91 51 97Z",
    fill: "#0a1820",
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140 92 Q145 87 138 82 Q135 85 138 90Z",
    fill: "#0a1820",
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150 97 Q158 91 152 85 Q148 88 151 94Z",
    fill: "#0a1820",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 0.8,
    fill: "#a0c0e0",
    opacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 10,
    r: 0.6,
    fill: "#c0d0f0",
    opacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 15,
    r: 0.5,
    fill: "#a0b0d0",
    opacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 12,
    r: 0.7,
    fill: "#b0c0e0",
    opacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 20,
    r: 0.9,
    fill: "#a0b0d0",
    opacity: 0.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 8,
    r: 0.5,
    fill: "#c0d0f0",
    opacity: 0.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 40,
    r: 0.6,
    fill: "#b0c0e0",
    opacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 35,
    r: 0.7,
    fill: "#a0b0d0",
    opacity: 0.4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 120 Q50 116 100 120 Q150 124 200 118",
    fill: "none",
    stroke: "#1a3848",
    strokeWidth: 0.5,
    opacity: 0.4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 135 Q60 130 120 134 Q160 136 200 132",
    fill: "none",
    stroke: "#162c3c",
    strokeWidth: 0.4,
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.e287d78240a43b7c2e5fb93381633e29.svg";
export { ForwardRef as ReactComponent };